import { inject as service } from '@ember/service';
import Controller from '@ember/controller';
import BillingService from 'cio/services/billing';
import { Plans } from 'cio/utils/billing/plans';

export default class TrialExpiredController extends Controller {
  @service billing!: BillingService;

  plans = [Plans.Essentials, Plans.Premium, Plans.Enterprise];

  get nextUpgradePlanType() {
    return this.billing.upgradePlanTypes.journeys;
  }
}

declare module '@ember/controller' {
  interface Registry {
    'trial-expired': TrialExpiredController;
  }
}
